import $ from 'jquery';

// On page load, if URL anchor is a toggle element, then activate it
$(function() {
  // Get anchor from URL
  const anchor = window.location.hash;

  if (anchor) {
    // Get element corresponding to anchor
    const $anchorElement = $(anchor);

    if ($anchorElement.is('[data-toggle="collapse"], [data-toggle="tab"]')) {
      $anchorElement.click();
    }
  }
})